import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Stack, Typography } from '@karma/components';
import GlobalSearchSection from 'components/organisms/GlobalSearchSection/GlobalSearchSection';
import GlobalItemCardsSection from 'components/organisms/GlobalItemCardsSection/GlobalItemCardsSection';
import SavedFromStoreCards from 'components/organisms/SavedFromStoreCards/SavedFromStoreCards';
import { getGlobalItemsGroup, getMyGlobalItemsGroup } from 'store/myItems/store/selectors';
import Alooma from 'services/alooma';
import * as ALOOMA from 'consts/alooma';
import { getQueryParam } from 'functions/urlHelpers';
import { QUERY_PARAMS } from 'consts/queryParams';
import RetailersSlider from 'components/organisms/RetailersSlider/RetailersSlider';

const GlobalSearchSuccessResults = ({ retailers }) => {
  const { t } = useTranslation();

  const query = getQueryParam(QUERY_PARAMS.query);

  const globalItemsGroup = useSelector(getGlobalItemsGroup);
  const myGlobalItemsGroup = useSelector(getMyGlobalItemsGroup);

  const myGlobalItemsTotalAmount = myGlobalItemsGroup.totalCount;
  const myGlobalItems = myGlobalItemsGroup.tags;

  const globalItems = globalItemsGroup.tags;

  const hasGlobalItems = !!globalItems?.length;
  const hasMyItems = !!myGlobalItems?.length;

  Alooma.usePageViewTracker();

  return (
    <Stack spacing={32} fullWidth direction="column" alignItems="flex-start">
      <Typography variant="h4">
        {t('app:youSearchedFor')} <span style={{ fontWeight: 600 }}>“{query}”</span>
      </Typography>

      {hasMyItems && (
        <Alooma.SectionContext.Provider value={ALOOMA.SECTIONS.SAVED_ITEMS}>
          <GlobalSearchSection
            title={t('app:yourSavedItems')}
            subtitle={t('app:itemFound', { count: myGlobalItemsTotalAmount })}
          >
            <SavedFromStoreCards />
          </GlobalSearchSection>
        </Alooma.SectionContext.Provider>
      )}

      {!!retailers?.length && (
        <>
          <Alooma.SectionContext.Provider value={ALOOMA.SECTIONS.STORES}>
            <GlobalSearchSection title={t('app:stores')} subtitle={t('app:storeFound', { count: retailers.length })}>
              <RetailersSlider retailers={retailers} />
            </GlobalSearchSection>
          </Alooma.SectionContext.Provider>
        </>
      )}

      {hasGlobalItems && (
        <Alooma.SectionContext.Provider value={ALOOMA.SECTIONS.OTHER_ITEMS}>
          <GlobalSearchSection title={t('app:itemsTitle')}>
            <GlobalItemCardsSection myItems={globalItems} />
          </GlobalSearchSection>
        </Alooma.SectionContext.Provider>
      )}
    </Stack>
  );
};

export default GlobalSearchSuccessResults;
